import React from 'react';
import {
  EmptyStateIllustration,
  ErrorIllustration,
  NoResultsIllustration,
  PendingIllustration,
  StaringWorkIllustration,
  SuccessIllustration,
  UnionIllustration
} from '../assets/Illustrations';

export type IllustrationType =
  | 'startingWork'
  | 'emptyState'
  | 'error'
  | 'noResults'
  | 'success'
  | 'pending'
  | 'noData';

export interface IllustrationsProps {
  type: IllustrationType;
}

export const Illustration: React.FC<IllustrationsProps> = ({ type }) => {
  const getIllustration = () => {
    switch (type) {
      case 'startingWork':
        return <StaringWorkIllustration />;
      case 'emptyState':
        return <EmptyStateIllustration />;
      case 'error':
        return <ErrorIllustration />;
      case 'noResults':
        return <NoResultsIllustration />;
      case 'success':
        return <SuccessIllustration />;
      case 'pending':
        return <PendingIllustration />;
      case 'noData':
        return <UnionIllustration />;
      default:
        return null;
    }
  };

  return <div>{getIllustration()}</div>;
};

